import { AccordionWizard as WizardComp } from './AccordionWizard';
import { AccordionWizardStep } from './AccordionWizard.Step';

export const AccordionWizard = Object.assign(WizardComp, {
  Step: AccordionWizardStep
});
